import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke052aRequest, Sgke052aResponse, Sgke052aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke052aService {

  /**
   * コンストラクタ
   * @param {Sgke052aService} sgke052aService
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke052aService
   */
  constructor(private service: Sgke052aService
    , private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 返金登録API呼び出し
   * @param {Sgke052aRequest} request
   * @return {*}  {Observable<Sgke052aResponse>}
   * @memberof UsedSgke052aService
   */
  public doSgke052a(request: Sgke052aRequest): Observable<Sgke052aResponse> {

    return this.service.ke10WSGKE052APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE052A');
          return throwError(err.message);
        })
      );
  }
}
